import "@/App.css";
import { LanguageProvider } from "@/i18n";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Pricing } from "@/components/Pricing";
import { Gallery } from "@/components/Gallery";
import { Panoramic } from "@/components/Panoramic";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <About />
          <Pricing />
          <Gallery />
          <Panoramic />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
